import script from "./ConnectedOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedOrders.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedOrders.vue?vue&type=style&index=0&id=0320cedb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0320cedb"]])

export default __exports__